module.exports = __webpack_public_path__ + "img/donation.308c92fc.png";